import React, { useEffect, useState } from "react";
import {
  Container, Row, Col,
} from "reactstrap";
import { provincesRepo } from "data/repositories/provincesRepo";
import { dealsRepo } from "data/repositories/dealsRepo";
import { businessesRepo } from "data/repositories/businessesRepo";
import { bookingsRepo } from "data/repositories/bookingsRepo";
import { subscriptionsRepo } from "data/repositories/subscriptionsRepo";
import { usersRepo } from "data/repositories/usersRepo";
import { Link } from "react-router-dom";
import { adminPaths } from "admin/paths";
import { supportRequestsRepo } from "data/repositories/supportRequestsRepo";
import { kadekonRepo } from "data/repositories/kadekonRepo";
import { getAdminDataSourceInfo } from "data/admin/dataSource";
import StatCard from "components/StatCard";

export default function AdminHome() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    const provinces = provincesRepo.list();
    const deals = dealsRepo.list();
    const businesses = businessesRepo.list();
    const bookings = bookingsRepo.list();
    const subs = subscriptionsRepo.list();
    const users = usersRepo.list();
    const supportRequests = supportRequestsRepo.list();

    setStats({
      provinces: provinces.length,
      deals: deals.length,
      businesses: businesses.length,
      bookings: bookings.length,
      pendingBookings: bookings.filter((b) => b.status === "pending").length,
      subscriptions: subs.length,
      activeSubs: subs.filter((s) => s.status === "active").length,
      users: users.length,
      supportRequests: supportRequests.length,
      openSupportRequests: supportRequests.filter((request) => request.status === "open").length,
      kadekonPending: 0,
      kadekonMembers: 0,
    });

    kadekonRepo
      .listApplications()
      .then((applications) => {
        setStats((current) => ({
          ...current,
          kadekonPending: applications.filter((item) => item.status === "pending").length,
        }));
      })
      .catch(() => {});

    kadekonRepo
      .listMembers()
      .then((members) => {
        setStats((current) => ({
          ...current,
          kadekonMembers: members.filter((item) => item.status === "active").length,
        }));
      })
      .catch(() => {});
  }, []);

  const dataSource = getAdminDataSourceInfo();

  return (
    <>
      <div className="header bg-gradient-dark pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Yönetim Paneli</h2>
          <p className="text-white opacity-8 mb-1">Genel bakış ve istatistikler</p>
          <small className="text-white opacity-8">Veri kaynağı: {dataSource.label}</small>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="mb-4">
          <Col lg={3} md={6} xs={12} className="mb-3">
            <StatCard title="Şehirler" value={stats.provinces || 0} icon="fas fa-map" color="info" />
          </Col>
          <Col lg={3} md={6} xs={12} className="mb-3">
            <StatCard title="Fırsatlar" value={stats.deals || 0} icon="fas fa-tags" color="success" />
          </Col>
          <Col lg={3} md={6} xs={12} className="mb-3">
            <StatCard title="İşletmeler" value={stats.businesses || 0} icon="fas fa-store" color="primary" />
          </Col>
          <Col lg={3} md={6} xs={12} className="mb-3">
            <StatCard title="Rezervasyonlar" value={stats.bookings || 0} icon="fas fa-calendar-check" color="warning" />
          </Col>
        </Row>

        <Row>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Bekleyen Rez." value={stats.pendingBookings || 0} icon="fas fa-clock" color="danger" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Abonelikler" value={stats.subscriptions || 0} icon="fas fa-crown" color="info" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Aktif Abonelik" value={stats.activeSubs || 0} icon="fas fa-check-circle" color="success" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Kullanıcılar" value={stats.users || 0} icon="fas fa-users" color="default" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Destek Talepleri" value={stats.supportRequests || 0} icon="fas fa-life-ring" color="warning" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <StatCard title="Açık Destek" value={stats.openSupportRequests || 0} icon="fas fa-inbox" color="danger" />
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <Link to={`/admin${adminPaths.admin.kadekon}`} style={{ textDecoration: "none" }}>
              <StatCard title="KADEKON bekleyen" value={stats.kadekonPending || 0} icon="fas fa-id-card" color="warning" />
            </Link>
          </Col>
          <Col lg={4} md={6} xs={12} className="mb-3">
            <Link to={`/admin${adminPaths.admin.kadekon}`} style={{ textDecoration: "none" }}>
              <StatCard title="KADEKON aktif üye" value={stats.kadekonMembers || 0} icon="fas fa-users" color="success" />
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
}
